import React, { useEffect, useState, useRef } from 'react';

import TextInputWithLabel from '../components/Inputs/TextInput.jsx';
import SelectWithLabel, { YesNoSelect } from '../components/Inputs/Select.jsx';
import ColourPicker from '../components/Inputs/ColourPicker.jsx';
import Card from '../components/Ui/Card.jsx';
import { Alert } from '../components/Ui/Alert.jsx';
import { fetchAccount, updateAccount, createTheme, updateTheme } from '../http/account.js'
import { TabbedCard } from '../components/Ui/Card.jsx';
import { TabController } from '../components/TabController/TabController.jsx';
import { TabPanel } from '../components/TabController/TabPanel.jsx';
import { TabContent } from '../components/StyledComponents/Tabs/Tabs.jsx';
import { CenterContainer, FormContainer } from '../components/StyledComponents/Forms/Forms.jsx';
import { DefaultButton, DefaultButtonSmall, DottedBorderButton, DottedBorderButtonWithLabel } from '../components/StyledComponents/Buttons/Buttons.jsx';
import { Row, FieldContainer, Heading, Paragraph } from '../components/StyledComponents/Forms/Forms.jsx';
import RichTextBoxWithLabel from '../components/Inputs/RichTextBoxWithLabel.jsx';
import { distributors, opticians } from '../components/Helpers/userTypes.js';
import { UploadDocument } from '../assets/icons/UploadDocument.jsx';


export default function Preferences({ colour, setSidebar, setAppName, email, accountType, setDefaultTheme }) {
  const [account, setAccount] = useState({});
  const [originalAccount, setOriginalAccount] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [validationWarning, setValidationWarning] = useState(null);

  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    const loadAccount = async () => {
      setIsLoading(true);
      try {
        const fetchedAccount = await fetchAccount(email);

        setOriginalAccount(fetchedAccount);
        setAccount(fetchedAccount.Users_Profile);

        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    };

    loadAccount();
  }, [email]);

  const handleOpticianChange = (field, value) => {
    setOriginalAccount(prev => ({
      ...prev,
      Optician_Profile: {
        ...prev.Optician_Profile,
        [field]: value,
      }
    }));
  };

  const discount = [
    { label: '20%', value: '20' },
    { label: '25%', value: '25' },
    { label: '30%', value: '30' }
  ];

  const handleUserChange = (field, value) => {
    setAccount(prev => ({ ...prev, [field]: value }));
  };

  function validateBankDetails() {

    if (originalAccount?.Optician_Profile?.feespaidby === 1 || originalAccount?.Optician_Profile?.feespaidby === '1') {
      if (!originalAccount?.Optician_Profile?.bank_holder_name || !originalAccount?.Optician_Profile?.bank_account_number || !originalAccount?.Optician_Profile?.bank_sort_code) {
        setFieldErrors({
          bank_holder_name: !originalAccount?.Optician_Profile?.bank_holder_name ? "Bank Holder Name is required." : null,
          bank_account_number: !originalAccount?.Optician_Profile?.bank_account_number ? "Bank Account Number is required." : null,
          bank_sort_code: !originalAccount?.Optician_Profile?.bank_sort_code ? "Bank Sort Code is required." : null,
        });

        return false;
      }
      if (originalAccount?.Optician_Profile?.bank_account_number.length !== 8) {
        setFieldErrors(prev => ({
          ...prev,
          bank_account_number: "Bank Account Number must be 8 digits."
        }));

        return false;
      } else {
        setFieldErrors(prev => ({
          ...prev,
          bank_account_number: null
        }));
      }
      if (/^\d{2}-\d{2}-\d{2}$/.test(originalAccount?.Optician_Profile?.bank_sort_code)) {
        if (originalAccount?.Optician_Profile?.bank_sort_code.replace(/-/g, '').length !== 6) {
          setFieldErrors(prev => ({
            ...prev,
            bank_sort_code: "Bank Sort Code must be 6 digits."
          }));
        }

      } else if (!/^\d{6}$/.test(originalAccount?.Optician_Profile?.bank_sort_code)) {
        if (originalAccount?.Optician_Profile?.bank_sort_code.length !== 6) {
          setFieldErrors(prev => ({
            ...prev,
            bank_sort_code: "Bank Sort Code must be 6 digits."
          }));

          return false;
        }
      } else {
        setFieldErrors(prev => ({
          ...prev,
          bank_sort_code: null
        }));
      }
    }

    setFieldErrors({});
    return true;
  }

  const handleSaveUserChanges = async () => {
    if (!colour.appName) {
      setValidationWarning("You must enter a value for My Company Name");
      return;
    }

    if (!validateBankDetails()) {
      return;
    }
    setIsLoading(true);
    setValidationWarning(null);
    try {
      if (/^\d{2}-\d{2}-\d{2}$/.test(originalAccount?.Optician_Profile?.bank_sort_code)) {
        originalAccount.Optician_Profile.bank_sort_code = originalAccount.Optician_Profile.bank_sort_code.replace(/-/g, '');
      }
      originalAccount.Users_Profile = account;
      await updateAccount(originalAccount);

      if (colour.isDefault) {
        await createTheme(colour, account.unqID);
        colour.isDefault = false;
      } else {
        await updateTheme(colour, account.unqID);
      }
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
      setSuccess(true);
    }
  };

  const fileInputRef = useRef(null);

  const handleUploadDocClick = () => {
    fileInputRef.current.click();
  };

  const handleDocumentUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        setOriginalAccount(prev => ({
          ...prev,
          Optician_Profile: {
            ...prev.Optician_Profile,
            bank_document_base64: base64String,
            bank_document_filename: file.name,
            bank_document_exists: true,
            bank_document_type: file.type,
          }
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const payOptions = [
    { label: 'Cheque', value: '0' },
    { label: 'BACS', value: '1', disabled:true }
  ];

  const expiry = [
    { label: '30 Days', value: '30' },
    { label: '60 Days', value: '60' },
    { label: '90 Days', value: '90' }
  ];

  function renderSidebar(type) {
    return (option) => {
      setSidebar(prevOptions => ({
        ...prevOptions,
        [type]: option
      }));
    };
  }

  return (
    <CenterContainer>
      <FormContainer>
        {opticians.includes(accountType) ? (
          <TabbedCard
            label={'Preferences'}
            headercolour={colour.sidebar}
            headerTextColour={colour.font}
            tabController={
              <TabController colours={colour}>
                <TabPanel label='Preferences' visible={true}>
                  <TabContent>
                    <Heading>Please choose your preferences from the options below</Heading>
                    <p>Reports (sent directly to you by email)</p>
                    <Row>
                      <FieldContainer>
                        <YesNoSelect label='Monthly Order Reports' value={account?.monthly_reports} onChange={e => handleUserChange('monthly_reports', e.target.value)} />
                      </FieldContainer>
                      <FieldContainer>
                        <YesNoSelect label='Monthly Eyewear Reminder?' value={account?.reminder_service} onChange={e => handleUserChange('reminder_service', e.target.value)} />
                      </FieldContainer>
                    </Row>
                    <p>Marketing</p>
                    <Row>
                      <FieldContainer>
                        <YesNoSelect label='Mailing List' value={account?.mailing_list} onChange={e => handleUserChange('mailing_list', e.target.value)} />
                      </FieldContainer>
                      <FieldContainer>
                        <YesNoSelect label='Customer Satisfaction Survey (EyeTicket Authorisers)' value={account?.marketresearch_optinout === 1 ? "Yes" : "No"} onChange={e => handleUserChange('marketresearch_optinout', (e.target.value === 'Yes' ? 1 : 0))} />
                      </FieldContainer>
                    </Row>
                    <p>Orders</p>
                    <Row>
                      <FieldContainer>
                        <YesNoSelect
                          label='Enable Daily Order Tracking By Default'
                          value={account?.IsDailyOrderStatusReportRequested === true ? "Yes" : "No"}
                          onChange={e => handleUserChange('IsDailyOrderStatusReportRequested', (e.target.value === 'Yes' ? true : false))} />
                      </FieldContainer>
                    </Row>
                    <YesNoSelect
                      label={
                        <>
                          Do you accept our GDPR Policy?{" "}
                          <a
                            href="https://www.mcrsafetyeurope.com/GDPR-Policy.aspx"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            (a copy can be found here)
                          </a>
                        </>
                      }
                      value={account?.GDPRPolicyAccepted === true ? "Yes" : "No"}
                      onChange={e => handleUserChange('GDPRPolicyAccepted', (e.target.value === 'Yes' ? true : false))}
                    />
                    <Alert type="info">We will not pass on your details to any third parties</Alert>
                    <p>Personalisation</p>
                    <Alert type='empty'>You can personalise the look and feel of the EyeTicket platform by changing the colour options below. You can also add a company logo within the Account Details page</Alert>
                    <Row>
                      <TextInputWithLabel
                        label='My Company Name'
                        width='50%'
                        required={true}
                        value={colour.appName}
                        onChange={e => setAppName(e.target.value)}
                      />
                      <DefaultButtonSmall onClick={setDefaultTheme}>Revert to default colour scheme</DefaultButtonSmall>
                    </Row>
                    <Row>
                      <FieldContainer>
                        <ColourPicker label='Menu colour' colour={colour.sidebar} setColour={renderSidebar('sidebar')} />
                      </FieldContainer>
                      <FieldContainer>
                        <ColourPicker label='Menu Content colour' colour={colour.menuContent} setColour={renderSidebar('menuContent')} />
                      </FieldContainer>
                      <FieldContainer>
                        <ColourPicker label='Hover colour' colour={colour.hoverColour} setColour={renderSidebar('hoverColour')} />
                      </FieldContainer>
                      <FieldContainer>
                        <ColourPicker label='Font colour' colour={colour.font} setColour={renderSidebar('font')} />
                      </FieldContainer>
                    </Row>
                  </TabContent>
                </TabPanel>
                <TabPanel label='Liability Cover & Miscellaneous' visible={true}>
                  <TabContent>
                    <p>Cover</p>
                    <Row>
                      <FieldContainer>
                        <YesNoSelect label='Do you have Professional Indemnity cover?' value={originalAccount?.Optician_Profile?.IndemnityCover === 1 ? "Yes" : "No"} onChange={e => handleOpticianChange('IndemnityCover', (e.target.value === 'Yes' ? 1 : 0))} />
                      </FieldContainer>
                      <FieldContainer>
                        <YesNoSelect label='Do you have Public Liability cover of a minimum of £5m?' value={originalAccount?.Optician_Profile?.PublicLiability === 1 ? "Yes" : "No"} onChange={e => handleOpticianChange('PublicLiability', (e.target.value === 'Yes' ? 1 : 0))} />
                      </FieldContainer>
                    </Row>
                    <p>Services</p>
                    <Row>
                      <FieldContainer>
                        <YesNoSelect label='Are You An Independent Optician?' value={originalAccount?.Optician_Profile?.independent === "1" ? "Yes" : "No"} onChange={e => handleOpticianChange('independent', (e.target.value === 'Yes' ? "1" : "0"))} />
                      </FieldContainer>
                      <FieldContainer>
                        <YesNoSelect label='Do You Want To Be On Our Approved Opticians List?' value={originalAccount?.Optician_Profile?.approved} onChange={e => handleOpticianChange('approved', e.target.value)} />
                      </FieldContainer>
                    </Row>
                    <Row>
                      <FieldContainer>
                        <YesNoSelect label='Do You have Fitting Frames?' value={originalAccount?.Optician_Profile?.framepack} onChange={e => handleOpticianChange('framepack', e.target.value)} />
                      </FieldContainer>
                      <FieldContainer>
                        <YesNoSelect label='Do You Offer An Locum Service?' value={originalAccount?.Optician_Profile?.onsite} onChange={e => handleOpticianChange('onsite', e.target.value)} />
                      </FieldContainer>
                    </Row>
                    <Row>
                      <FieldContainer>
                        <YesNoSelect label='Can You Offer The Jaeger Sight Test For The Aerospace Industry?' value={originalAccount?.Optician_Profile?.jaeger === 1 ? "Yes" : "No"} onChange={e => handleOpticianChange('jaeger', (e.target.value === 'Yes' ? 1 : 0))} />
                      </FieldContainer>
                      <FieldContainer>
                        <YesNoSelect label='Do You Want To Be Listed In Our Opticians Directory?' value={originalAccount?.Optician_Profile?.directory} onChange={e => handleOpticianChange('directory', e.target.value)} />
                      </FieldContainer>
                    </Row>
                  </TabContent>
                </TabPanel>
                <TabPanel label='Opticians Professional Fees' visible={true}>
                  <TabContent>
                    <p>Opticians Professional Fees</p>
                    <Row>
                      <FieldContainer>
                        <SelectWithLabel
                          label='Fees Paid By'
                          options={payOptions}
                          value={originalAccount?.Optician_Profile?.feespaidby}
                          onChange={e => handleOpticianChange('feespaidby', e.target.value)}
                        />
                      </FieldContainer>
                    </Row>
                    <Row>
                      <FieldContainer>
                        <TextInputWithLabel
                          label="Sight Test Fee"
                          type="number"
                          value={originalAccount?.Optician_Profile?.fee}
                          onChange={e => handleOpticianChange('fee', e.target.value)}
                          currency="£" />
                      </FieldContainer>
                      <FieldContainer>
                        <TextInputWithLabel currency="£" label="Single Vision" type="number" value={originalAccount?.Optician_Profile?.sv_fee} onChange={e => handleOpticianChange('sv_fee', e.target.value)} />
                      </FieldContainer>
                    </Row>
                    <Row>
                      <FieldContainer>
                        <TextInputWithLabel currency="£" label="Bi-Focal" type="number" value={originalAccount?.Optician_Profile?.bf_fee} onChange={e => handleOpticianChange('bf_fee', e.target.value)} />
                      </FieldContainer>
                      <FieldContainer>
                        <TextInputWithLabel currency="£" label="Vari-Focal" type="number" value={originalAccount?.Optician_Profile?.vf_fee} onChange={e => handleOpticianChange('vf_fee', e.target.value)} />
                      </FieldContainer>
                    </Row>
                    <FieldContainer>
                      <YesNoSelect label='Will You Process EyeTicket™ Orders Online?' value={originalAccount?.Optician_Profile?.eticket} onChange={e => handleOpticianChange('eticket', e.target.value)} />
                    </FieldContainer>
                    {(originalAccount?.Optician_Profile?.feespaidby === 1 || originalAccount?.Optician_Profile?.feespaidby === '1') && (
                      <>
                        <p>Bank Details</p>
                        <Row>
                          <FieldContainer>
                            <TextInputWithLabel
                              label="Bank Holder Name"
                              type="text"
                              value={originalAccount?.Optician_Profile?.bank_holder_name}
                              invalidData={fieldErrors.bank_holder_name}
                              onChange={e => handleOpticianChange('bank_holder_name', e.target.value)} />
                          </FieldContainer>
                        </Row>
                        <Row>
                          <FieldContainer>
                            <TextInputWithLabel
                              label="Bank Account Number"
                              type="text"
                              value={originalAccount?.Optician_Profile?.bank_account_number}
                              invalidData={fieldErrors.bank_account_number}
                              onChange={e => handleOpticianChange('bank_account_number', e.target.value)} />
                          </FieldContainer>
                          <FieldContainer>
                            <TextInputWithLabel
                              label="Bank Sort Code"
                              type="text"
                              value={originalAccount?.Optician_Profile?.bank_sort_code}
                              invalidData={fieldErrors.bank_sort_code}
                              onChange={e => handleOpticianChange('bank_sort_code', e.target.value)} />
                          </FieldContainer>
                        </Row>
                        <Row>
                          <FieldContainer>
                            <DottedBorderButtonWithLabel
                              label="Upload Bank Vertification Document"
                              icon={<UploadDocument />}
                              onClick={handleUploadDocClick}
                              style={{ width: '100%', height: '50px' }}>
                              Upload Document
                            </DottedBorderButtonWithLabel>
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                              ref={fileInputRef}
                              style={{ display: 'none' }}
                              onChange={handleDocumentUpload}
                            />
                            {originalAccount?.Optician_Profile?.bank_document_exists && (
                              <Alert type='info'>
                                A bank verification document is already on file. Uploading a new document will overwrite the existing one when you save changes.
                              </Alert>
                            )}
                          </FieldContainer>
                        </Row>
                      </>)}
                  </TabContent>
                </TabPanel>
                <TabPanel label="EyeTicket For DSE Programme" visible={opticians.includes(accountType)}>
                  <TabContent>
                    <Heading>EyeTicket For DSE Programme</Heading>
                    <Paragraph>Do you want to be part of our DSE programme where you have the opportunity to get our patient to upgrade to frame and lenses in your store and take the cash sale?
                      Please agree a professional fee which covers sight test and dispensing which is paid to you regardless of what the patient requires to be part of the programme. This <b>ONLY</b> applies for DSE.</Paragraph>
                    <FieldContainer>
                      <YesNoSelect label='Do You Want To Join Our DSE Programme?' value={account.dse_upgrade === 1 ? "Yes" : "No"} onChange={e => handleUserChange('dse_upgrade', (e.target.value === 'Yes' ? 1 : 0))} />
                    </FieldContainer>
                    <Row>
                      <FieldContainer>
                        <TextInputWithLabel disabled={!account.dse_upgrade} label="Professional Fee" type="number" value={originalAccount?.Optician_Profile?.pf_fee} onChange={e => handleOpticianChange('pf_fee', e.target.value)} />
                      </FieldContainer>
                      <FieldContainer>
                        <SelectWithLabel disabled={!account.dse_upgrade} label='Discount To Patient (When Upgrading DSE Only)' options={discount} value={originalAccount?.Optician_Profile?.dsediscount} onChange={e => handleOpticianChange('dsediscount', e.target.value)} />
                      </FieldContainer>
                    </Row>
                    <Heading>Other Benefits For MCR Safety Patients</Heading>
                    <Paragraph>Why not give MCR Safety clients an incentive to choose your practice, such as 15% off any private orders. Your benefits will be listed in our directory and can be seen when our client raises EyeTicket orders.</Paragraph>
                    <RichTextBoxWithLabel disabled={!account.dse_upgrade} value={originalAccount?.Optician_Profile?.promotions} onChange={e => handleOpticianChange('promotions', e.target.value)} />
                  </TabContent>
                </TabPanel>
              </TabController>
            }
          >
            {success && <Alert type='success'>Account updated successfully</Alert>}
            {validationWarning && <Alert type='warning'>{validationWarning}</Alert>}
            <DefaultButton
              onClick={handleSaveUserChanges}
              disabled={isLoading}>Save Changes</DefaultButton>
            {isLoading && <p>Loading...</p>}
            {error && !isLoading && <Alert type="error">Unable to render page due to <b>{error.message}</b></Alert>}
          </TabbedCard>
        ) : (
          <Card label={'Preferences'} headercolour={colour.sidebar} headerTextColour={colour.font}>
            {isLoading && <p>Loading...</p>}
            {error && !isLoading && <Alert type="error">Unable to render page due to <b>{error.message}</b></Alert>}
            {!isLoading && !error && (
              <>
                <Heading>Please choose your preferences from the options below</Heading>
                <p>Reports (sent directly to you by email)</p>
                <Row>
                  <FieldContainer>
                    <YesNoSelect label='Monthly Order Reports' value={account.monthly_reports} onChange={e => handleUserChange('monthly_reports', e.target.value)} />
                  </FieldContainer>
                  <FieldContainer>
                    <YesNoSelect label='Monthly Eyewear Reminder?' value={account.reminder_service} onChange={e => handleUserChange('reminder_service', e.target.value)} />
                  </FieldContainer>
                </Row>
                <p>Marketing</p>
                <Row>
                  <FieldContainer>
                    <YesNoSelect label='Mailing List' value={account.mailing_list} onChange={e => handleUserChange('mailing_list', e.target.value)} />
                  </FieldContainer>
                  <FieldContainer>
                    <YesNoSelect label='Customer Satisfaction Survey (EyeTicket Authorisers)' value={account.marketresearch_optinout === 1 ? "Yes" : "No"} onChange={e => handleUserChange('marketresearch_optinout', (e.target.value === 'Yes' ? 1 : 0))} />
                  </FieldContainer>
                </Row>
                <Alert type="info">We will not pass on your details to any third parties</Alert>
                {!distributors.includes(accountType) &&
                  <>
                    <p>EyeTicket</p>
                    <SelectWithLabel label=" EyeTickets to expire after" options={expiry} value={account.expire_etickets} onChange={e => handleUserChange('expire_etickets', e.target.value)} />
                    <YesNoSelect
                      label='EyeTicket For DSE Programme'
                      value={"No"}
                      disabled />
                    <YesNoSelect label='Do You Use Non-Prescription Safety Eyewear?' value={account.useplano} onChange={e => handleUserChange('useplano', e.target.value)} />
                    <YesNoSelect
                      label={
                        <>
                          Do you accept our GDPR Policy?{" "}
                          <a
                            href="https://www.mcrsafetyeurope.com/GDPR-Policy.aspx"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            (a copy can be found here)
                          </a>
                        </>
                      }
                      value={account?.GDPRPolicyAccepted === true ? "Yes" : "No"}
                      onChange={e => handleUserChange('GDPRPolicyAccepted', (e.target.value === 'Yes' ? true : false))}
                    />

                  </>}
                <p>Orders</p>
                <Row>
                  <FieldContainer>
                    <YesNoSelect
                      label='Enable Daily Order Tracking By Default'
                      value={account?.IsDailyOrderStatusReportRequested === true ? "Yes" : "No"}
                      onChange={e => handleUserChange('IsDailyOrderStatusReportRequested', (e.target.value === 'Yes' ? true : false))} />
                  </FieldContainer>
                </Row>
                <p>Personalisation</p>
                <Alert type='empty'>You can personalise the look and feel of the EyeTicket platform by changing the colour options below. You can also add a company logo within the Account Details page</Alert>
                <Row>
                  <TextInputWithLabel
                    label='My Company Name'
                    width='50%'
                    required={true}
                    value={colour.appName}
                    onChange={e => setAppName(e.target.value)}
                  />
                  <DefaultButtonSmall onClick={setDefaultTheme}>Revert to default colour scheme</DefaultButtonSmall>
                </Row>
                <Row>
                  <FieldContainer>
                    <ColourPicker label='Menu colour' colour={colour.sidebar} setColour={renderSidebar('sidebar')} />
                  </FieldContainer>
                  <FieldContainer>
                    <ColourPicker label='Menu Content colour' colour={colour.menuContent} setColour={renderSidebar('menuContent')} />
                  </FieldContainer>
                  <FieldContainer>
                    <ColourPicker label='Hover colour' colour={colour.hoverColour} setColour={renderSidebar('hoverColour')} />
                  </FieldContainer>
                  <FieldContainer>
                    <ColourPicker label='Font colour' colour={colour.font} setColour={renderSidebar('font')} />
                  </FieldContainer>
                </Row>
                {success && <Alert type='success'>Account updated successfully</Alert>}
                {validationWarning && <Alert type='warning'>{validationWarning}</Alert>}
                <DefaultButton
                  onClick={handleSaveUserChanges}
                  disabled={isLoading}>Save Changes</DefaultButton>
              </>
            )}
          </Card>
        )}
      </FormContainer>
    </CenterContainer>
  );
}
